import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel'
import { usePrivacyPolicyDocument } from 'shared/hooks'
import { priceShow } from 'shared/lib/priceShow.ts'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { CheckBox } from 'shared/ui/check-box'

import s from './styles.module.scss'

interface Props {
  price: number
  passengers: number
  prepayment: number
  onClick: () => void
}

export const PrepaymentButton = ({
  price,
  passengers,
  prepayment,
  onClick,
}: Props) => {
  const { t } = useTranslation()
  const { openPrivacyPolicy } = usePrivacyPolicyDocument()

  const [isAgreementChecked, setIsAgreementChecked] = useState(false)

  const onApply = () => {
    onClick()
  }

  const handleLinkClick = (
    e: React.MouseEvent<HTMLSpanElement>,
    field: keyof PrivacyPolicyModel,
  ) => {
    e.stopPropagation()
    void openPrivacyPolicy(field)
  }

  const handleCheckboxChange = (checked?: boolean) => {
    const isChecked = !!checked
    setIsAgreementChecked(isChecked)
  }

  return (
    <ButtonContinue
      onClick={onApply}
      className={clsx('semi-bold-17', s.btn)}
      disabled={!isAgreementChecked}
      slot={
        <>
          <div className={s.slot}>
            <span className={clsx('bold-16', s.text)}>
              {t('umrah_block.price', { count: passengers })}
            </span>

            <span className={clsx('extra-bold-18', s.text)}>
              {priceShow(String(price))} &#8384;
            </span>
          </div>

          <div className={s.agreement}>
            <div className={s.checkBox}>
              <CheckBox
                isChecked={isAgreementChecked}
                onClick={handleCheckboxChange}
                title={
                  <>
                    {/*TODO изменить ссылки когда добавят на бэке*/}
                    {t('tours_block.confirm_offer')}{' '}
                    <span
                      className={s.offerLink}
                      onClick={(e) => handleLinkClick(e, 'base_public_offer')}
                    >
                      {t('tours_block.offer_terms')}
                    </span>{' '}
                    {/* {t('tours_block.and')}{' '} */}
                    {/* <span
                      className={s.offerLink}
                      onClick={(e) =>
                        handleLinkClick(e, 'umra_politic_privacy_offer')
                      }
                    >
                      {t('tours_block.privacy_policy')}
                    </span> */}
                  </>
                }
              />
            </div>
          </div>
        </>
      }
    >
      <span>
        {t('umrah_block.make_advance', {
          price: priceShow(String(prepayment)),
        })}
      </span>
    </ButtonContinue>
  )
}
